/**
 * IPTV Lists Service - Firestore storage for IPTV list URLs
 */
import { db } from "./firebase";
import { collection, doc, getDocs, addDoc, deleteDoc, setDoc, query, orderBy } from "firebase/firestore";

const COLLECTION_NAME = "iptvLists";

// Default lists to seed if collection is empty
const DEFAULT_LISTS = [
  { name: "🇪🇸 España", url: "https://www.m3u.cl/lista/ES.m3u" },
  { name: "🇲🇽 México", url: "https://www.m3u.cl/lista/MX.m3u" },
  { name: "🇦🇷 Argentina", url: "https://www.m3u.cl/lista/AR.m3u" },
  { name: "🇨🇱 Chile", url: "https://www.m3u.cl/lista/CL.m3u" },
];

/**
 * Get all IPTV lists from Firestore
 * Seeds default lists if collection is empty
 */
export async function getIPTVLists() {
  try {
    const listsCollection = collection(db, COLLECTION_NAME);
    const q = query(listsCollection, orderBy("name"));
    const snapshot = await getDocs(q);

    // If empty, seed with default lists
    if (snapshot.empty) {
      console.log("Seeding default IPTV lists...");
      for (const list of DEFAULT_LISTS) {
        await addDoc(listsCollection, {
          ...list,
          createdAt: new Date().toISOString(),
        });
      }
      // Fetch again after seeding
      const newSnapshot = await getDocs(q);
      return newSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    }

    return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error("Error fetching IPTV lists:", error);
    // Return default lists if Firestore fails
    return DEFAULT_LISTS.map((list, index) => ({ id: `default-${index}`, ...list }));
  }
}

/**
 * Add a new IPTV list
 */
export async function addIPTVList(name, url) {
  try {
    const listsCollection = collection(db, COLLECTION_NAME);
    const docRef = await addDoc(listsCollection, {
      name,
      url,
      createdAt: new Date().toISOString(),
    });
    return { id: docRef.id, name, url };
  } catch (error) {
    console.error("Error adding IPTV list:", error);
    return null;
  }
}

/**
 * Delete an IPTV list
 */
export async function deleteIPTVList(listId) {
  try {
    await deleteDoc(doc(db, COLLECTION_NAME, listId));
    return true;
  } catch (error) {
    console.error("Error deleting IPTV list:", error);
    return false;
  }
}

/**
 * Update an IPTV list
 */
export async function updateIPTVList(listId, name, url) {
  try {
    await setDoc(
      doc(db, COLLECTION_NAME, listId),
      {
        name,
        url,
        updatedAt: new Date().toISOString(),
      },
      { merge: true },
    );
    return true;
  } catch (error) {
    console.error("Error updating IPTV list:", error);
    return false;
  }
}
